<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Add Many QR Codes</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">

  <form (submit)="addMany()" (keydown.enter)="addMany()" #form="ngForm">
    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>QR Code Type</mat-label>
      <mat-select [(ngModel)]="feature" name="feature" required>
        <mat-option value="Access Control">Site Access Control</mat-option>
        <mat-option value="Asset">Asset</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Number</mat-label>
      <input
        matInput
        [(ngModel)]="codesCount"
        name="codesCount"
        type="number"
        max="1000000"
        placeholder="Number"
        required/>
    </mat-form-field>

    <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Name</mat-label>
      <input
        matInput
        [(ngModel)]="name"
        name="name"
        type="text"
        maxlength="255"
        placeholder="Name"/>
    </mat-form-field>
  </form>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="px-3 py-2">
  <button
    class="my-2 ml-1 mr-2"
    type="button"
    mat-raised-button
    color="primary"
    (click)="addMany()"
    [disabled]="form?.invalid || inProgress">
    Add
  </button>
</mat-dialog-actions>
